// used on awa
import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Components } from '@ionic/core';
import { StaffService } from '../staff/staff.service';
import { ModalComponent, ModalAlertComponent } from '../modal-alert/modal-alert.component';
import { ModalController } from '@ionic/angular';
import { UserData } from '../users/user-data';
import { AuthServiceProvider } from '../users/auth-service/auth-service';

interface UserAgency {
  Id: number;
  Name: string;
}

interface UserAgencyRoles {
  AgencyId: number;
  Role: string;
}

@Component({
  selector: 'user-agency',
  templateUrl: './user-agency.component.html',
  styleUrls: ['./user-agency.component.scss'],
})
export class UserAgencyComponent implements OnInit {
  public userAgencyForm: FormGroup;
  loading = false;
  userAgencies: any = [];
  selectedAgencyText: any = 'Choose an Agency to Proceed';
  agencyType: any;
  @Input() userName;
  @Input() agencies;
  @Input() roles;
  @Input() modal: Components.IonModal;
  rolesByAgencyId: any = [];

  constructor(public router: Router, public formBuilder: FormBuilder,
    public modalController: ModalController,
    public userData: UserData,
    public authService: AuthServiceProvider,
    public staffService: StaffService) {
    this.userAgencyForm = formBuilder.group({
      agencyId: ['', [Validators.required, Validators.minLength(14)]],
    });
  }

  ngOnInit() {
    console.log(this);
    this.userAgencyForm.valueChanges.subscribe(change => {
      if (this.userAgencyForm.dirty) {
        this.modal.backdropDismiss = false;
      }
    });

    this.userAgencies = this.userAgencies.map((a: string) => JSON.parse(a) as UserAgency);

    this.roles.forEach((jsonString: string) => {
      const parsed = JSON.parse(jsonString);
      const role = Number(parsed.Role);
      this.rolesByAgencyId[parsed.AgencyId] = role;
    });

  }

  selectionChanged(event) {
    console.log('Use ', event[0].data.Name)
    this.selectedAgencyText = 'Use ' + event[0].data.Name;
  }

  updateUserAgency() {
    console.log(this.userAgencyForm.value);
    var data = {
      agencyId: this.userAgencyForm.value.agencyId,
      role: this.rolesByAgencyId[this.userAgencyForm.value.agencyId]
    }
    this.modal.dismiss(data);
  }

  async logout() {
    const options: ModalComponent = {
      header: 'Logout',
      body: 'Are you sure you want to log out?',
      model: { canLogout: true }
    };

    const modal = await this.modalController.create({
      component: ModalAlertComponent,
      componentProps: {
        props: options
      }
    });

    modal.onDidDismiss().then(({ data }) => {
      if (data.model) {
        const { canLogout } = data.model;
        if (canLogout) {
          this.userData.logout().then(() => {
            this.authService.signOut();
          });
        }
      }
    });
    return await modal.present();
  }
}

